const items: { label: string; href: string; external?: boolean }[] = [
  { label: 'PVMA 2024 Bacolod', href: '/evidence' },
  { label: 'WVAC 2024 Cape Town', href: '/evidence' },
  { label: 'FECAVA 2025 Antwerp', href: '/evidence' },
  { label: 'AVMA 2025 Washington DC', href: '/evidence' },
  { label: 'WVAC 2026 Tokyo', href: '/evidence' },
];

export default function TrustBar() {
  return (
    <div className="w-full bg-transparent border-b border-border/30">
      <div className="container-max px-4 sm:px-6 lg:px-8 py-1.5">
        <ul className="flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 text-[11px] sm:text-xs text-muted-foreground">
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-3">
              <a
                href={item.href}
                {...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                className="font-medium text-foreground/80 hover:text-foreground transition-colors underline-offset-2 hover:underline"
              >
                {item.label}
              </a>
              {i < items.length - 1 && <span className="text-muted-foreground/60" aria-hidden>·</span>}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
